import { Check, Plane, BedDouble, Stethoscope, Flag } from "lucide-react";

const STEPS = [
  { key: "PENDING", label: "Funds in Escrow", icon: Flag },
  { key: "CLINIC_CHECKIN", label: "Clinic Check-in", icon: Stethoscope },
  { key: "CLINIC_DISCHARGE", label: "Discharge", icon: BedDouble },
  { key: "COMPLETED", label: "Completed", icon: Check },
];

export default function EscrowTracker({ status }) {
  const order = STEPS.map((s) => s.key);
  const current = order.indexOf(status);

  return (
    <div className="flex items-center justify-between" data-testid="escrow-tracker">
      {STEPS.map((s, i) => {
        const done = i <= current;
        const Icon = s.icon;
        return (
          <div key={s.key} className="flex-1 flex items-center last:flex-none">
            <div className="flex flex-col items-center gap-2" data-testid={`escrow-step-${s.key}`}>
              <div
                className={`grid place-items-center h-11 w-11 rounded-full border-2 transition-colors duration-200 ${
                  done
                    ? "bg-[#12B76A] border-[#12B76A] text-white"
                    : "bg-white border-[#E4E7EC] text-muted-foreground"
                }`}
              >
                <Icon size={20} />
              </div>
              <span className={`text-xs font-medium text-center max-w-[80px] ${done ? "text-[#101828]" : "text-muted-foreground"}`}>
                {s.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div className={`h-0.5 flex-1 mx-1 -mt-6 rounded ${i < current ? "bg-[#12B76A]" : "bg-[#E4E7EC]"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
